const data = 
[
    {
        "brand": "GoPro",
        "camera": "GoPro5",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.60",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on,please make sure the GoPro in taking picture mode,swipt down from homepage to find \"CONNECT\", tap \"Connect New Device\", click \"Capture App\"\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro6",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.01",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the camera on, please make sure the GoPro in taking picture mode, swipt down from homepage to find \"Connections\", tap \"Connect New Device\", click \"GoPro App\"\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 SILVER",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", next, tap \"connect to GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, \n3.GoPro returns to the homepage manually.\n4.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n5.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n6.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.90",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the camera on, please make sure the GoPro in recording mode, then turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", click \"Connect Device\",next, tap \"GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. \n3.After the connection is successful, we will hear the camera beep,\n4.Single tap the gimbal's shutter button,\n5.GoPro camera back to the homepage,after tap the back icon for GoPro,which will prompt up \"PAIRING STOPPED\", please wait some time till \"Pairing stopped\" disappeared.\n6.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n7.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n8.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 White",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.10",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", click \"Connect to GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.GoPro returns to the homepage manually\n4.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n5.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n6.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro8 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.51",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, please make sure the GoPro in taking picture mode,swipt down from homepage to find \"Preferences\", tap \"Connections\", click  \"Connect Device\", next, choose \" GoPro App\"/\"Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro9 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.72",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Connections\", tap \"Connect Device\", next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.46",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Connections\", tap \"Connect Device\", next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro11",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.12",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Preferences\", tap \"Wireless Connections\",click \"Connect Device\",next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro Max",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.09",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, please make sure the GoPro in taking picture mode,swipt down from homepage to find \"Preferences\", tap \"Connections\",click \"Connect Device\", next, choose \" GoPro App\"/\"Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture.\n5.Please make sure the gimbal's Gimbal firmware/Remote firmware/motor firmware are in V1.09 or above, and the bluetooth firmware is in V1.03 or above."
    }
]

export default data